import { MenuItem, Select } from "@mui/material";
import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';

const MarketCode = ({ data, getData, setLocationId, locationId, setPage }) => {
  const [selectedValue, setSelectedValue] = useState(locationId);
  useEffect(() => {
    getData(1);
    setPage(1);
  }, [selectedValue]);
  
  return (
    <Select
      style={{ width: "10%", height: "40px", marginRight:"10px" }}
      required
      displayEmpty
      renderValue={locationId !== "" ? undefined : () => "Select Location"}
      value={selectedValue}
      onChange={(e) => {
        setLocationId(e.target.value);
        setSelectedValue(e.target.value);
      }}
    >
      {data.map((item, index) => (
        <MenuItem key={index+""} value={item.id}>
          {item.location_name} {item?.agency?.marketCode? `(${item?.agency?.marketCode})`: ""}
        </MenuItem>
      ))}
    </Select>
  );
};
MarketCode.propTypes = {
  data: PropTypes.any,
  getData: PropTypes.any,
  setLocationId: PropTypes.any,
  locationId: PropTypes.any,
  setPage: PropTypes.any,
};


export default MarketCode;
